import Table from '../../../../utils/ResultViewer/Table'

class DataViewTable extends Table {
  renderRow(row: any, key: string, colIndex: number): JSX.Element {
    return super.renderRow(row, key, colIndex)
  }
}

export default DataViewTable
